import { Component, OnInit, OnDestroy, ViewChild, ElementRef,HostListener } from '@angular/core';
import { DealerService } from '../services/dealer.service';
import { UsersService } from '../services/users.service';
import { DealerPlanService } from '../services/service-plan.service';
import { CommonService } from '../services/common.service';
import { WebsocketService } from '../services/websocket.service';
import { Modal } from '../model/modal';
import { Helper } from "../../4services/2helper"
import { BaseComponent } from '@app/directives/base-component';
import { takeUntil } from 'rxjs/operators';

declare var $zoho: any;

@Component({
    selector: 'app-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss'],
    standalone: false
})
export class TopNavComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('search') search_input: ElementRef;
  @ViewChild('searcher') searcher: ElementRef;
  @ViewChild('noticeSelect') noticeSelect: ElementRef;
  @ViewChild('helpSelect') helpSelect: ElementRef;
  me = this.users.me;
  snd;

  dealerName = '';
  dealerPlan = '';
  dealerPlanType = 1;
  hasViewDealerPlanPermission = false
  dealerInfo = null;

  isShowDowngradeWarning = false
  nextDealerPlan = ''

  isInit = false;

  search_width = 160;
  search_text = '';

  searched_users = [];
  searched_sites = [];
  searched_devices = [];

  sectionVisible = {
    users: true,
    sites: true,
    devices: true,
  }

  timer: any;
  searchMsg = '';
  isSearching = false;

  isReadNoticeList: any = {
    'automation-rules': false,
    'video-storage-and-cloud-api': false,
    'cloud-ai': false,
  };
  isReadAllNotice = false;
  isOpenNotiMenu = false;
  isOpenHelpMenu = false;
  isShowVideos = false;

  isADCLinked = false;
  isOELinked = false;
  exp_adc = [];
  exp_oe = [];

  m_profile: Modal = new Modal()
  m_warning: Modal = new Modal()
  m_dealer_plan_modal: Modal = new Modal()

  currentEnv = ''
  envs = ['dev', 'qe', 'prod']
  isLocalHost = window.location.hostname === 'localhost'

  constructor(
    public dealerService: DealerService,
    public users: UsersService,
    public dealerPlanService: DealerPlanService,
    public commonService: CommonService,
    private websocket: WebsocketService,
    private helper: Helper
  ) {
    super();
  }

  async ngOnInit() {
    if (this.isInit) return;

    await this.loadUser();
    this.subscribeDealerPlanChanges();
    this.checkAllReadNotice();
    this.initSoundEffect();
    this.currentEnv = localStorage.getItem('chekt::env') || 'dev';
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.websocket.mqttRelease();
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.searcher && !this.noticeSelect && !this.helpSelect) {
      return;
    }

    // Zoho 채팅 위젯 클릭 시 무시
    const target = event.target as HTMLElement;
    if (target.closest('#zsiqwidget') || target.closest('[id^="zsiq"]') || target.closest('[class*="zsiq"]')) {
      return;
    }

    if (this.searcher) {
      if (!this.searcher.nativeElement.contains(event.target)) {
        this.focusoutSearch();
      }
    }
    if(this.noticeSelect){
      if (!this.noticeSelect.nativeElement.contains(event.target)) {
        this.isOpenNotiMenu = false;
      }
    }
    if (this.helpSelect) {
      if (!this.helpSelect.nativeElement.contains(event.target)) {
        this.isOpenHelpMenu = false;
        this.isShowVideos = false;
      }
    }
  }
  // --------------------------------------------------------
  // Init
  async loadUser() {
    this.dealerName = this.me()?.company_name;

    this.handlePermissions(this.me()?.permissions);
    this.websocket.mqttInit(this.me()?.access_token);
    await this.loadDealerInfo();

    this.isInit = true;
  }

  async loadDealerInfo(){
    const res = await this.helper.dealer.get_dealer_info()
    if (!res) return;
    this.dealerInfo = res[0]
    this.parseExpDealerInfo();
  }

  handlePermissions(permissions: any): void {
    this.initSalesIQ();

    this.hasViewDealerPlanPermission = !!permissions?.has_payment_permission;
  }


  /** 딜러 플랜 변경 감지 */
  subscribeDealerPlanChanges(): void {
    this.dealerPlanService.dealerPlanType$s
      .pipe(takeUntil(this.destroy$))
      .subscribe(val => {
        const planType = val?.current_month_service_plan_type;
        const nextMonthPlanType = val?.next_month_service_plan_type;

        this.dealerPlanType = planType;
        this.dealerPlan = this.parseServicePlanTypeToPlanName(planType);

        if (planType > nextMonthPlanType) {
          this.isShowDowngradeWarning = true;
          this.nextDealerPlan = this.parseServicePlanTypeToPlanName(nextMonthPlanType);
        }
      });
  }

  initSoundEffect(): void {
    this.snd = new Audio('assets/effects/chat.mp3');
  }

  parseServicePlanTypeToPlanName(type){
    switch(type){
      case(1) : return 'Basic'
      case(2) : return 'Professional'
      case(3) : return 'Premium'
      case(4) : return 'Reseller'
      default : return 'Basic'
    }
  }

  setEnv(env: string) {
    localStorage.setItem('chekt::env', env);
    this.currentEnv = env;
    window.location.reload();
  }

  // --------------------------------------------------------
  temp = null
  checkAllReadNotice(){
    const localKeyList = Object.keys(this.isReadNoticeList)
    localKeyList.forEach(key => {
      const localKey = 'CHeKTUser_' + key
      let notice = JSON.parse(localStorage.getItem(localKey));
      notice ? this.isReadNoticeList[key] = true : this.isReadNoticeList[key] = false
      this.isReadAllNotice = Object.values(this.isReadNoticeList).every(v => v === true)
    })
  }

  getDealerName() {
    return this.users.me()?.company_name || '';
  }

  getDealerId() {
    return this.users.dealerId();
  }
  
  parseExpDealerInfo() {
    const list = this.dealerInfo?.exp_dealer_info ?? [];
  
    this.exp_oe = list.filter(v => v.registered_by_partner === 'OE');
    this.exp_adc = list.filter(v => v.registered_by_partner === 'ADC');
  
    this.isOELinked = this.exp_oe.length > 0;
    this.isADCLinked = this.exp_adc.length > 0;
  }

  getPartnerConnectedByEmail(){
    return this.dealerInfo?.partner_connected_by_email
  }

  isShowADCLinkTooltip = false;
  isShowOELinkTooltip = false;

  computedDealerPlan() {
    return this.dealerPlanType === 1
      ? 'current-badge'
      : 'upgrade-badge'
  }

  openSearch() {
    this.search_text = '';
    this.search_input.nativeElement.focus();
  }

  focusSearch() {
    this.search_width = 320;
  }

  focusoutSearch() {
    setTimeout(_ => {
      this.search_width = 160;
      this.search_text = '';
      this.searchMsg = '';
      this.searched_users = [];
      this.searched_sites = [];
      this.searched_devices = [];
    }, 100);
  }

  searchEvent() {
    this.searched_users = [];
    this.searched_sites = [];
    this.searched_devices = [];
    this.searchMsg = '';
    if (this.search_text.length < 3) {
      this.searchMsg = 'Search word is short.';
      clearTimeout(this.timer);
      return;
    } else if (this.search_text.length === 0) {
      this.searchMsg = '';
      clearTimeout(this.timer);
      return;
    }

    this.isSearching = true;
    const delay = 500;
    clearTimeout(this.timer);
    this.searchMsg = 'Searching...';
    this.timer = setTimeout(() => {
      if (this.search_text.length === 0) return;

      this.dealerService.search(this.me()?.dealer_id, this.search_text)
        .pipe(takeUntil(this.destroy$))
        .subscribe(res => {
          this.searched_users = res.users;
          this.searched_sites = res.sites;
          this.searched_devices = res.devices.sort((a, b) => a.type - b.type);
          const count = res.users.length + res.sites.length + res.devices.length;
          if (count > 100) {
            this.searchMsg = 'You have more than 100 search results. Please enter more specific search words.';
          } else if (count === 0) {
            this.searchMsg = 'No result.';
          } else {
            this.searchMsg = '';
          }
          this.isSearching = false;
        }, err => {
          this.isSearching = false;
        });
    }, delay);
  }

  toggleSection(section: 'users' | 'sites' | 'devices') {
    this.sectionVisible[section] = !this.sectionVisible[section]
  }

  checkResult() {
    if (this.search_text.length < 2) return true;
    if (this.searched_users.length === 0 && this.searched_sites.length === 0 && this.searched_devices.length === 0) {
      return false;
    }
    return true;
  }

  gotoUsers(user) {
    this.focusoutSearch();
    this.helper.router.navigate_to('/settings/users', { user: user.user_id });
  }

  gotoSites(site) {
    this.focusoutSearch();
    this.helper.router.navigate_to('/customers', { id: site.site_id });
  }

  gotoDevices(device) {
    this.focusoutSearch();
    this.helper.router.navigate_to('/customers', { id: device.site_id, device_id: device.device_id });
  }

  goToDealerPlanDescription(){
    if(!this.hasViewDealerPlanPermission) return
    this.helper.router.navigate_to_service_plan();
  }

  bootIntercom(name?: string, email?: string, created_at?: number) {
    if (name && email && created_at) {
      window['Intercom']('boot', {
        app_id: 'owfc73xh',
        name: name,
        email: email,
        created_at: created_at
      });
    }
  }

  private loadZohoScript(): Promise<void> {
    if (typeof $zoho !== 'undefined' && $zoho.salesiq) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      // Zoho SalesIQ 글로벌 설정
      const w = window as any;
      w.$zoho = w.$zoho || {};
      w.$zoho.salesiq = w.$zoho.salesiq || {
        widgetcode: 'ef1f3c45cc7cc847c2b1feac101cffc8315db17f88bd6e2388f18df54472e43e',
        values: {},
        ready: () => resolve()
      };

      // 위젯 컨테이너 추가
      if (!document.getElementById('zsiqwidget')) {
        const div = document.createElement('div');
        div.id = 'zsiqwidget';
        document.body.appendChild(div);
      }

      // 스크립트 로드
      const script = document.createElement('script');
      script.id = 'zsiqscript';
      script.src = 'https://salesiq.zoho.com/widget';
      script.defer = true;
      document.head.appendChild(script);
    });
  }

  async initSalesIQ() {
    try {
      await this.loadZohoScript();

      if (this.me() && typeof $zoho !== 'undefined' && $zoho.salesiq) {
        $zoho.salesiq.visitor.name(`${this.me()?.firstname} ${this.me()?.lastname}`);
        $zoho.salesiq.visitor.email(this.me()?.email);

        $zoho.salesiq.floatbutton.position('left');
        $zoho.salesiq.floatbutton.visible('show');

        // Prevent floatbutton from being hidden
        if ($zoho.salesiq.floatbutton) {
          const originalButtonVisible = $zoho.salesiq.floatbutton.visible;
          $zoho.salesiq.floatbutton.visible = function(action: string) {
            if (action === 'hide') {
              return;
            }
            return originalButtonVisible.call($zoho.salesiq.floatbutton, action);
          };
        }
      }
    } catch (error) {
      console.error('Error initializing SalesIQ:', error);
    }
  }

  // NOTIFICATION FUNCTION
  goToNoticeDescription(feature){
    this.isOpenNotiMenu = false;
    this.m_dealer_plan_modal.data['feature'] = feature
    this.m_dealer_plan_modal.data['type'] = 'plan-description'
    this.m_dealer_plan_modal.open()

    const localKey = 'CHeKTUser_' + feature;
    let notice = JSON.parse(localStorage.getItem(localKey));
    if(!notice) {
      this.isReadNoticeList[feature] = true // 후에는 모든 알람을 읽어야 변경
      localStorage.setItem(localKey, JSON.stringify(true));
      this.isReadAllNotice = Object.values(this.isReadNoticeList).every(v => v === true)
    }
  }

  onCloseDealerPlanModal(){
    this.dealerPlanService.getDealerPlan(this.me()?.dealer_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe()
  }

  // HELP FUNCTION
  toggleHelpMenu() {
    this.isOpenHelpMenu = !this.isOpenHelpMenu;
    if(!this.isOpenHelpMenu) this.isShowVideos = false;
  }

  goToDocPage() {
    const url = 'https://support.chekt.com/portal/en/kb/chekt';
    window.open(url, '_blank');
    this.isOpenHelpMenu = false;
    this.isShowVideos = false;
  }

  async showSalesIQModal() {
    if (!this.me()) return;
    this.isOpenHelpMenu = false;
    this.isShowVideos = false;

    try {
      await this.loadZohoScript();

      if (typeof $zoho !== 'undefined' && $zoho.salesiq) {
        const floatBtn = document.querySelector('#zsiq_float') as HTMLElement;
        if (floatBtn) {
          floatBtn.click();
        } else if ($zoho.salesiq.chatwindow && typeof $zoho.salesiq.chatwindow.open === 'function') {
          $zoho.salesiq.chatwindow.open();
        } else if ($zoho.salesiq.floatwindow && typeof $zoho.salesiq.floatwindow.visible === 'function') {
          $zoho.salesiq.floatwindow.visible('show');
        }
      }
    } catch (error) {
      console.error('Error opening chat window:', error);
    }
  }

  gotoDPOverViewVideo(){
    this.isOpenHelpMenu = false;
    this.isShowVideos = false;
    window.open('https://youtu.be/E4ICy_4d3CE?si=uJH_h1okKUkZyrDr', '_blank');
  }
  gotoHowToAddSite(){
    this.isOpenHelpMenu = false;
    this.isShowVideos = false;
    window.open('https://youtu.be/EJdF27JsTow?si=pbArB5o2_BJiT7Xl', '_blank');
  }
  gotoHowToAddBridge(){
    this.isOpenHelpMenu = false;
    this.isShowVideos = false;
    window.open('https://youtu.be/UouAnzoypnA?si=rHmUOalRrB5mmFUs', '_blank');
  }
  gotoHowToAddCam(){
    this.isOpenHelpMenu = false;
    this.isShowVideos = false;
    window.open('https://youtu.be/AOP5Y2utNU4?si=URUavVI7JDwV62q-', '_blank');
  }
}
